import type { DefaultCmsDataResponse, Image, File } from '../types';

export interface Category {
  slug: string;
  count: number;
  description: string;
  link: null;
  createdAt: Date;
  updatedAt: Date;
  publishedAt: Date;
  locale: string;
  parent: number;
  name: string;
}

export interface PostTag {
  createdAt: Date;
  updatedAt: Date;
  publishedAt: Date;
  locale: string;
  name: string;
  slug: string;
  count: number;
  link: null;
  description: string;
}

export interface Post {
  title: string;
  content: string;
  author: number;
  slug: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  summary: string;
  thumbnail_url: string;
  link?: string;
  external_link?: string;
  file: {
    data: DefaultCmsDataResponse<File>;
  };
  images: {
    data: DefaultCmsDataResponse<Image>[];
  };
  categories: {
    data: DefaultCmsDataResponse<Category>[];
  };
  tags: {
    data: DefaultCmsDataResponse<PostTag>[];
  };
  follow?: boolean;
  index?: boolean;
  canonical_url?: string;
}

export enum DisplayCategory {
  KHACH_HANG = 'khach-hang',
  TAI_XE = 'tai-xe',
  AHAMOVERS = 'ahamovers',
  DOI_TAC = 'doi-tac',
  DONG_HANH_CUNG_THUONG_HIEU = 'dong-hanh-cung-thuong-hieu',
}

export enum DisplayCategoryBlog {
  THONG_TIN_DICH_VU = 'thong-tin-dich-vu',
  KIEN_THUC_GIAO_HANG = 'kien-thuc-giao-hang',
  // kinh doanh
  KINH_NGHIEM_MO_CUA_HANG = 'kinh-nghiem-mo-cua-hang',
  BAN_HANG_ONLINE = 'ban-hang-online',
  KINH_DOANH_TREN_FACEBOOK = 'kinh-doanh-tren-facebook',
  KINH_DOANH_TREN_SHOPEE = 'kinh-doanh-tren-shopee',
  KINH_DOANH_TREN_TIKTOK_SHOP = 'kinh-doanh-tren-tiktok-shop',
  KINH_DOANH_TREN_LAZADA = 'kinh-doanh-tren-lazada',
  KIEN_THUC_MAR_KETING = 'kien-thuc-marketing',
  Y_TUONG_KINH_DOANH = 'y-tuong-kinh-doanh',
  CHO_DAU_MOI = 'cho-dau-moi',
  CACH_NHAP_HANG = 'cach-nhap-hang',
  KHO_BAI = 'kho-bai',
}

export const displayCategories: Record<
  string,
  { id: number; slug: string; name: string }
> = {
  [DisplayCategory.KHACH_HANG]: {
    id: 2,
    slug: DisplayCategory.KHACH_HANG,
    name: 'Khách hàng',
  },
  [DisplayCategory.TAI_XE]: {
    id: 5,
    slug: DisplayCategory.TAI_XE,
    name: 'Tài xế',
  },
  [DisplayCategory.AHAMOVERS]: {
    id: 152,
    slug: DisplayCategory.AHAMOVERS,
    name: 'Ahamovers',
  },
  [DisplayCategory.DOI_TAC]: {
    id: 3,
    slug: DisplayCategory.DOI_TAC,
    name: 'Đối tác',
  },
  [DisplayCategory.DONG_HANH_CUNG_THUONG_HIEU]: {
    id: 8,
    slug: DisplayCategory.DONG_HANH_CUNG_THUONG_HIEU,
    name: 'Đồng hành cùng Thương hiệu',
  },
};

export const displayCategoriesBlog: Record<
  string,
  { id: number; slug: string; name: string; group?: string }
> = {
  [DisplayCategoryBlog.THONG_TIN_DICH_VU]: {
    id: 9,
    slug: DisplayCategoryBlog.THONG_TIN_DICH_VU,
    name: 'Thông tin dịch vụ',
  },
  [DisplayCategoryBlog.KIEN_THUC_GIAO_HANG]: {
    id: 10,
    slug: DisplayCategoryBlog.KIEN_THUC_GIAO_HANG,
    name: 'Kiến thức giao hàng',
  },
};
